import { render, staticRenderFns } from "./AboutBox.vue?vue&type=template&id=6eaa2790&scoped=true"
import script from "./AboutBox.vue?vue&type=script&lang=ts"
export * from "./AboutBox.vue?vue&type=script&lang=ts"
import style0 from "./AboutBox.vue?vue&type=style&index=0&id=6eaa2790&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaa2790",
  null
  
)

export default component.exports